import { createSvgIcon } from '@mui/material';

const IconInfoOutlined = createSvgIcon(
  <>
    <path d="M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10Zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Z" />
    <path d="M11 11h2v6h-2z" />
    <path d="M11 7h2v2h-2z" />
  </>,
  'info_outlined'
);

export default IconInfoOutlined;
